const TIERS_STANDARD = [
  { id: "schriftlich", label: "Schriftliche Auswertung", price: "ab sofort per E-Mail" },
  { id: "audio", label: "WhatsApp-Sprachnachricht", price: "per WhatsApp Audio" },
  { id: "live", label: "1:1 Live-Sitzung", price: "per Telefon oder Video" },
];

export const services = [
  // ── Energetische Sessions ──────────────────────────────────────────────────
  {
    id: "wirbelsaeulenaufrichtung",
    name: "Energetische Wirbelsäulenaufrichtung",
    category: "energie",
    categoryLabel: "Energie",
    badge: "BELIEBT",
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftliche Auswertung", price: "111 €" },
      { id: "audio", label: "WhatsApp-Sprachnachricht", price: "144 €" },
      { id: "live", label: "1:1 Live-Sitzung", price: "222 €" },
    ],
    startingFrom: "111 €",
    shortDescription:
      "Harmonisierung des Energiesystems · Lösung von Blockaden · Mehr innere Stabilität",
    fullDescription:
      "Bei der energetischen Wirbelsäulenaufrichtung wird das Energiesystem harmonisiert und die natürliche Aufrichtung des Körpers unterstützt. Durch gezielte energetische Impulse können Blockaden gelöst und der Energiefluss wieder in Balance gebracht werden. Je nach Situation kann die Arbeit durch den Einsatz eines Pendels oder Karten ergänzt werden.",
    bookingType: "modal",
    disclaimer: true,
  },
  {
    id: "morphisches-feld-reading",
    name: "Reading im morphischen Feld",
    category: "energie",
    categoryLabel: "Energie",
    badge: null,
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftliche Auswertung", price: "144 €" },
      { id: "audio", label: "WhatsApp-Sprachnachricht", price: "177 €" },
      { id: "live", label: "1:1 Live-Sitzung", price: "277 €" },
    ],
    startingFrom: "144 €",
    shortDescription:
      "Tiefere Muster erkennen · Emotionale Blockaden sichtbar machen · Neue Perspektiven",
    fullDescription:
      "Ein Reading im morphischen Feld dient dazu, tiefere Informationen, Muster und Zusammenhänge auf energetischer Ebene wahrzunehmen. Dabei können aktuelle Themen, emotionale Blockaden oder verborgene Potenziale sichtbar werden. Das Reading unterstützt dich dabei, mehr Klarheit, Bewusstsein und neue Perspektiven für deinen Lebensweg zu erhalten. Je nach Situation kann die Arbeit durch den Einsatz eines Pendels oder Karten ergänzt werden.",
    bookingType: "modal",
    disclaimer: true,
  },
  {
    id: "fremdenergie-clearing",
    name: "Fremdenergie-Clearing",
    category: "energie",
    categoryLabel: "Energie",
    badge: null,
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftliche Auswertung", price: "133 €" },
      { id: "audio", label: "WhatsApp-Sprachnachricht", price: "166 €" },
      { id: "live", label: "1:1 Live-Sitzung", price: "255 €" },
    ],
    startingFrom: "133 €",
    shortDescription:
      "Energetische Reinigung · Fremdeinflüsse lösen · Zurück in die eigene Kraft",
    fullDescription:
      "Belastende Energien, emotionale Fremdeinflüsse oder energetische Anhaftungen werden wahrgenommen und gelöst. Ziel ist es, dein eigenes Energiefeld zu reinigen und wieder mehr in deine eigene Kraft und innere Balance zu kommen. Die Anwendung kann befreiend, klärend und stabilisierend wirken. Je nach Situation kann die Arbeit durch den Einsatz eines Pendels oder Karten ergänzt werden.",
    bookingType: "modal",
    disclaimer: true,
  },
  {
    id: "tierkommunikation",
    name: "Tierkommunikation",
    category: "tiere",
    categoryLabel: "Tiere",
    badge: null,
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftliche Auswertung", price: "144 €" },
      { id: "audio", label: "WhatsApp-Sprachnachricht", price: "177 €" },
      { id: "live", label: "1:1 Live-Sitzung", price: "277 €" },
    ],
    startingFrom: "144 €",
    shortDescription:
      "Intuitiver Kontakt zu deinem Tier · Gefühle & Bedürfnisse verstehen · Verbindung stärken",
    fullDescription:
      "Durch eine intuitive und energetische Verbindung werden Gefühle, Bedürfnisse und Botschaften des Tieres wahrgenommen. Die Session unterstützt ein tieferes Verständnis und kann die Verbindung zwischen Mensch und Tier stärken. Bitte sende vorab ein aktuelles Foto deines Tieres.",
    bookingType: "modal",
    tierNote: true,
  },

  // ── Premium Aufstellungen ──────────────────────────────────────────────────
  {
    id: "familienaufstellung",
    name: "Familienaufstellung",
    category: "aufstellung",
    categoryLabel: "Aufstellung",
    badge: "PREMIUM",
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftlich", price: "222 €" },
      { id: "audio", label: "Audio", price: "277 €" },
      { id: "live", label: "1:1 Sitzung", price: "444 €" },
    ],
    startingFrom: "222 €",
    shortDescription:
      "Systemische Aufstellung · Familienmuster erkennen · Tiefe Transformation",
    fullDescription:
      "Energetische Aufstellungen machen verborgene Zusammenhänge, unbewusste Muster und systemische Verstrickungen sichtbar. Die Familienaufstellung eröffnet neue Perspektiven und kann dabei unterstützen, Klarheit, Verständnis und innere Ordnung zu fördern.",
    bookingType: "modal",
  },
  {
    id: "ahnenaufstellung",
    name: "Ahnenaufstellung",
    category: "aufstellung",
    categoryLabel: "Aufstellung",
    badge: "PREMIUM",
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftlich", price: "222 €" },
      { id: "audio", label: "Audio", price: "277 €" },
      { id: "live", label: "1:1 Sitzung", price: "444 €" },
    ],
    startingFrom: "222 €",
    shortDescription:
      "Ahnenlinien erkennen · Transgenerationale Muster lösen · Heilung über Generationen",
    fullDescription:
      "In der Ahnenaufstellung werden transgenerationale Muster, Loyalitäten und ungelöste Themen aus den Ahnenlinien sichtbar gemacht. Durch das Sichtbarmachen tiefer liegender Dynamiken werden neue Lösungswege und Heilungspotenziale erkennbar.",
    bookingType: "modal",
  },
  {
    id: "partnerschaftsaufstellung",
    name: "Partnerschaftsaufstellung",
    category: "aufstellung",
    categoryLabel: "Aufstellung",
    badge: "PREMIUM",
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftlich", price: "199 €" },
      { id: "audio", label: "Audio", price: "255 €" },
      { id: "live", label: "1:1 Sitzung", price: "399 €" },
    ],
    startingFrom: "199 €",
    shortDescription:
      "Beziehungsdynamiken verstehen · Muster in der Partnerschaft · Neue Ordnung finden",
    fullDescription:
      "Die Partnerschaftsaufstellung macht verborgene Dynamiken, Loyalitäten und Muster in der Paarbeziehung sichtbar. Ob in einer bestehenden Partnerschaft oder zur Vorbereitung auf neue Beziehungen – diese Methode eröffnet tiefe Einblicke und neue Möglichkeiten.",
    bookingType: "modal",
  },
  {
    id: "business-aufstellung",
    name: "Business- & Erfolgsaufstellung",
    category: "aufstellung",
    categoryLabel: "Aufstellung",
    badge: "PREMIUM",
    mode: "Remote",
    pricingTiers: [
      { id: "schriftlich", label: "Schriftlich", price: "255 €" },
      { id: "audio", label: "Audio", price: "333 €" },
      { id: "live", label: "1:1 Sitzung", price: "555 €" },
    ],
    startingFrom: "255 €",
    shortDescription:
      "Berufliche Blockaden lösen · Erfolgs- und Geldthemen klären · Unternehmensdynamiken",
    fullDescription:
      "Die Business- & Erfolgsaufstellung macht energetische Blockaden, Glaubenssätze und systemische Verstrickungen im beruflichen Bereich sichtbar. Ob Karriere, Selbstständigkeit oder Unternehmensentwicklung – neue Perspektiven und Handlungsoptionen werden erkennbar.",
    bookingType: "modal",
  },

  // ── Weitere Leistungen (auf Anfrage) ───────────────────────────────────────
  {
    id: "systemische-aufstellungen",
    name: "Integrale & systemische Aufstellungen",
    category: "aufstellung",
    categoryLabel: "Aufstellung",
    badge: null,
    mode: "Individuell",
    pricingTiers: null,
    startingFrom: "auf Anfrage",
    shortDescription:
      "Für Familien · Alleinerziehende · Kindergärten & pädagogische Einrichtungen",
    fullDescription:
      "Integrale und systemische Aufstellungen für Familien, Alleinerziehende sowie Kindergärten und pädagogische Einrichtungen. Individuelle Begleitung, die auf die spezifischen Bedürfnisse von Familiensystemen und Gemeinschaften eingeht. Bitte nimm Kontakt auf für ein persönliches Erstgespräch.",
    bookingType: "contact",
  },
  {
    id: "kinder-jugendcoach",
    name: "Kinder- & Jugendcoach",
    category: "coaching",
    categoryLabel: "Coaching",
    badge: null,
    mode: "Individuell",
    pricingTiers: null,
    startingFrom: "auf Anfrage",
    shortDescription:
      "Energetische Begleitung für Kinder & Jugendliche · Stärkung der Ressourcen · Elternberatung",
    fullDescription:
      "Als Kinder- und Jugendcoach begleite ich junge Menschen energetisch und systemisch auf ihrem Weg. Themen wie Schulstress, soziale Herausforderungen, Ängste oder Entwicklungsphasen werden einfühlsam und altersgerecht bearbeitet. Eltern werden aktiv in den Prozess einbezogen.",
    bookingType: "contact",
  },
];

export const filterCategories = [
  { id: "alle", label: "Alle" },
  { id: "energie", label: "Energie" },
  { id: "aufstellung", label: "Aufstellungen" },
  { id: "tiere", label: "Tiere" },
  { id: "coaching", label: "Coaching" },
];
